import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ProgressSteps" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "ProgressSteps__title" }, "Рассчитать стоимость", -1)
const _hoisted_3 = { class: "ProgressSteps__steps" }
const _hoisted_4 = { class: "step__icon" }
const _hoisted_5 = {
  key: 1,
  class: "step__number"
}
const _hoisted_6 = { class: "step__name" }
const _hoisted_7 = { class: "ProgressSteps__lines" }
const _hoisted_8 = {
  class: "lines__bg",
  height: "3",
  viewBox: "0 0 4000 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("line", {
  x1: "100%",
  y1: "0%",
  x2: "0%",
  y2: "100%",
  style: {"stroke":"rgb(234, 243, 234)","stroke-width":"5"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_checkmark = _resolveComponent("icon-checkmark")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step, i) => {
        return (_openBlock(), _createBlock("div", {
          key: step.id,
          class: ["steps__step", {
                    'step--active': _ctx.isStepActive(step),
                    'step--completed': _ctx.isStepCompleted(step),
                    'step--available': _ctx.isStepAvailable(step)
                }],
          onClick: ($event: any) => (_ctx.setActiveStep(step))
        }, [
          _createVNode("div", _hoisted_4, [
            (_ctx.isStepCompleted(step))
              ? (_openBlock(), _createBlock(_component_icon_checkmark, {
                  key: 0,
                  class: "icon__svg"
                }))
              : (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(i + 1), 1))
          ]),
          _createVNode("div", _hoisted_6, _toDisplayString(step.name), 1)
        ], 10, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_7, [
      (_openBlock(), _createBlock("svg", _hoisted_8, [
        _hoisted_9,
        (_ctx.completagePercent > 0)
          ? (_openBlock(), _createBlock("line", {
              key: 0,
              x1: `${_ctx.completagePercent}%`,
              y1: "0%",
              x2: "0%",
              y2: "100%",
              style: {"stroke":"#90C91C","stroke-width":"5"}
            }, null, 8, ["x1"]))
          : _createCommentVNode("", true)
      ]))
    ])
  ]))
}